module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._m(0), " ", _vm._h('div', {
    staticClass: "main-page",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_vm._h('div', {
    staticClass: "margin-15 text-center"
  }, [_vm._h('p', {
    staticClass: "padding-15 margin-15 font-16"
  }, ["面对面扫一扫，邀请家长添加学生"]), " ", _vm._m(1), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('p', {
    staticClass: "padding-15 gray"
  }, ["您还可以发邀请到"]), " ", _vm._h('div', {
    staticClass: "shall padding-15"
  }, [_vm._h('div', {
    staticClass: "clearfix font-10"
  }, [_vm._h('div', {
    staticClass: "col-xs-4"
  }, [_vm._h('a', {
    staticClass: "icon-weixin icon gray",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareToFriends()
      }
    }
  }, ["家长的微信"])]), " ", _vm._h('div', {
    staticClass: "col-xs-4"
  }, [_vm._h('a', {
    staticClass: "icon-qq icon gray",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareQQ()
      }
    }
  }, ["家长的QQ"])]), " ", _vm._h('div', {
    staticClass: "col-xs-4"
  }, [_vm._h('router-link', {
    staticClass: "icon-shoudong icon gray",
    attrs: {
      "to": {
        path: '/student/add'
      }
    }
  }, ["手动添加"])])])])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["添加学生 / 家长"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "margin-15"
  }, [_vm._h('div', {
    staticClass: "text-center",
    attrs: {
      "id": "code"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-19d6749e!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/invitation/parents.vue
// module id = 183
// module chunks = 1